import React from 'react';

import http from 'Demora/http';

import Loading from 'Demora/Loading';

import { Link } from 'react-router-dom';

import image from 'Demora/image';

import classnames from 'classnames';

import ReduxConnect from 'Demora/redux-connect';

import '../../SurfBar/ads.scss';

import Newsfeed from './Newsfeed';

import LinkOrA from '../../LinkOrA';

import SanitizedHTML from 'react-sanitized-html';

import * as Sentry from '@sentry/react';

const getProfileUIDFromParam = () => {
	const urlParams = new URLSearchParams(window.location.search);
	return urlParams.get('uid');
};

class UserProfile extends React.Component {
	constructor(props) {
		super();

		this.state = {
			dropdownOpen: false,
			userProfile: null,
			uid: props.uid || getProfileUIDFromParam() || props.user.id || '',
		};
	}

	componentDidMount() {
		this.getUserData();
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.uid != prevState.uid) {
			this.setState({
				userProfile: null,
			});

			this.getUserData();
		}
	}

	static getDerivedStateFromProps(props, state) {
		const uid = props.uid || getProfileUIDFromParam() || props.user.id || '';
		if (uid != state.uid) {
			return {
				uid: uid,
			};
		}

		return null;
	}

	getUserData() {
		const uid = this.state.uid;

		const t = typeof uid;

		if (uid && t === 'string' && uid.match(/[^0-9]/)) {
			document.location = '/404';
			return;
		} else {
			http
				.get('/data/user_profile/' + uid)
				.then((data) => {
					var sc = {};

					if (!data.user || data.user.id < 1) {
						document.location = '/login';
					} else {
						data.user.cjup = data.user.cjup;

						if (!data.user.first_name) {
							document.location = '/404';
							return;
						}

						if (data.user) {
							var eu = this.props.user.id ? '_' : '';

							for (var i in data.user.wop) {
								if (data.user.wop[i] && data.user.wop[i].id) {
									data.user.wop[i].link =
										'/_' + eu + data.user.wop[i].id.toString(36);
								}
							}

							data.user.testimonial = data.user.testimonial.replace(
								/\n/g,
								'<br />'
							);
						}

						const w = data.user.news;
						w.$id = this.state.uid + '-u-n';

						this.setState({
							userProfile: data,
							news: w,
						});
					}
				})
				.catch((e) => {
					Sentry.captureException(e);
				});
		}
	}

	render() {
		const state = this.state;

		const props = this.props;

		if (!state.userProfile) {
			return (
				<div className='mt-3'>
					<Loading />
				</div>
			);
		}

		const userProfile = state.userProfile;

		const user_id = props.user.id;

		return (
			<div className='mx-auto pt-3' style={{ maxWidth: '980px' }}>
				{userProfile.user.show_connect_button && (
					<div className='row'>
						<div
							className='col-12 text-center'
							style={{ marginBottom: '40px' }}
						>
							<h3>
								Connect your CashJuice profile to your Traffic Ad Bar account!
							</h3>
							<form
								action='https://cashjuice.com/oauth/request'
								method='GET'
								target='_blank'
							>
								<input type='hidden' name='client_id' value='1' />
								<input
									type='hidden'
									name='redirect_uri'
									value='https://trafficadbar.com/data/cashjuice/oauth'
								/>
								<input type='hidden' name='scope' value='user profile_url' />
								<input type='hidden' name='response_type' value='code' />
								<input
									type='hidden'
									name='dem_rf0'
									value={userProfile.user.cj_referrer}
								/>
								<input
									className='btn btn-danger'
									type='submit'
									value='Click here to connect'
								/>
							</form>
						</div>
					</div>
				)}
				{!user_id && (
					<div>
						<div
							className='mx-auto p-3 bg-light'
							style={{
								fontSize: '16px',
								border: 'solid 3px #000',
								width: '90%',
								borderRadius: '20px',
							}}
						>
							<div className='row'>
								<div className='col-12 text-center text-primary h4'>
									Traffic Ad Bar specializes in helping people like you to...
									<br />
									<br />
								</div>
								<div className='col-12 col-md-6'>
									1. Market Yourself <br />
									2. Get More Targeted Traffic to Your Websites <br />
									3. Put Yourself in a Position to Make More Money <br />
									<br />
								</div>
								<div className='col-12 col-md-6'>
									You can learn how to get a FREE Profile Page that you can
									personalize for your use to better market you... and to
									advertise your programs
									<br />
									<a href={'/' + userProfile.user.username}>
										<b>by clicking here now...</b>
									</a>
								</div>
							</div>
						</div>
						{userProfile.user.cjup && <br />}
					</div>
				)}
				{!userProfile.user.cjup && (
					<div>
						{user_id && (
							<div
								className='mx-auto p-3 bg-light'
								style={{
									fontSize: '16px',
									border: 'solid 3px #000',
									width: '90%',
									borderRadius: '20px',
								}}
							>
								<div className='row'>
									<div className='col-12 col-md-6'>
										<h4>Promote Your Profile Page</h4>
										<h6>
											Learn how you can have your personalized profile page just
											like the one you're viewing now rotated among all TAB
											members.
										</h6>
									</div>
									<div className='col-12 col-md-6'>
										You'll be...
										<br />
										1. Branding Yourself
										<br />
										2. Getting More Traffic to Your Websites
										<br />
										3. Putting Yourself in a Position to Make More Money!
										<br />
										Go Learn How{' '}
										<Link to='/website_traffic/home/upgrade/' target='_top'>
											<b> by Clicking Here...</b>
										</Link>
									</div>
								</div>
							</div>
						)}
						<br />
						<div style={{ width: '90%' }} className='clearfix'>
							<div style={{ float: 'left', width: '150px' }}>
								<img
									style={{ width: '150px', height: '150px' }}
									className='rounded'
									src={image(userProfile.user.image, 150)}
								/>
							</div>
							<div style={{ marginLeft: '150px', padding: '0 5px 0 20px' }}>
								<h1 style={{ marginTop: 0 }}>{userProfile.user.first_name}</h1>
								<div
									style={{
										margin: 'auto',
										color: '#000',
										fontSize: '14px',
										maxHeight: '100px',
										overflow: 'hidden',
										overflowY: 'scroll',
									}}
								>
									<SanitizedHTML
										allowedTags={['br']}
										html={userProfile.user.testimonial}
									/>
								</div>
							</div>
						</div>
						<br />
					</div>
				)}
				<div className='row'>
					{userProfile.user.cjup && (
						<div className='col-12 col-sm-8' style={{ maxWidth: '780px' }}>
							<iframe
								src={userProfile.user.cjup}
								referrerPolicy='no-referrer-when-downgrade'
								style={{
									border: 0,
									margin: 0,
									padding: 0,
									width: '100%',
									height: '2000px',
								}}
							></iframe>
						</div>
					)}
					{(!userProfile.user.cjup || user_id === 0) && (
						<div className='col-12 col-sm-8' style={{ maxWidth: '480px' }}>
							{
								<Newsfeed
									uid={user_id}
									userProfile={userProfile}
									news={this.state.news}
								/>
							}
						</div>
					)}
					<div
						className={classnames('col-12', user_id === 0 ? '' : 'col-sm-4')}
					>
						<div className='text-center'>
							<h3>
								Click on one of{' '}
								<span style={{ color: '#AC0101', backgroundColor: '#FFFF00' }}>
									{userProfile.user.first_name}'s
								</span>{' '}
								websites
							</h3>
						</div>
						<ul className='z5ta clearfix mx-auto'>
							{userProfile.user.wop.map((a, i) => {
								return (
									<li
										key={i}
										style={{
											width: '190px',
											padding: '3px',
											float: 'left',
											listStyleType: 'none',
										}}
									>
										<div className='z52'>
											<LinkOrA
												className='z51'
												onClick={props.clickAd}
												onKeyDown={props.clickAd}
												onMouseDown={props.clickAd}
												rel='nofollow'
												to={a.link + '?u=1'}
											>
												{a.title}
											</LinkOrA>
											<div className='z53'>
												{a.desc1} {a.desc2}
											</div>
											<div className='z54'>
												<LinkOrA
													className='z55'
													onClick={props.clickAd}
													onKeyDown={props.clickAd}
													onMouseDown={props.clickAd}
													rel='nofollow'
													to={a.link + '?u=1'}
												>
													{a.website_url}
												</LinkOrA>
											</div>
										</div>
									</li>
								);
							})}
						</ul>
					</div>
				</div>
			</div>
		);
	}
}

export default ReduxConnect(UserProfile, {
	user: 'user',
});
